var _filter, _filter2, _filter3, _filter4, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 25.2115,
    width: 28.16,
    x: 2.05505,
    y: 3.28467
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.564706 0 0 0 0 0.635294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_18_4830"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 25.2615,
    width: 27.91,
    x: 2.05505,
    y: 3.38467
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.513726 0 0 0 0 0.784314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_18_4830"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_18_4830",
    mode: "normal",
    result: "effect2_innerShadow_18_4830"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 2.44053,
    width: 6.98765,
    x: 16.1564,
    y: 3.65596
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_18_4830",
    stdDeviation: 0.1
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 2.33433,
    width: 6.70042,
    x: 2.42219,
    y: 3.70625
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_18_4830",
    stdDeviation: 0.1
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 29.965,
    x2: 2.05505,
    y1: 15.479,
    y2: 15.479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfb1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237699,
    stopColor: "#c3b5cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256926,
    stopColor: "#ded3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487655,
    stopColor: "#ebe1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50777,
    stopColor: "#c5b9cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740516,
    stopColor: "#c7bcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76011,
    stopColor: "#efe3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3d7e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 13.3909,
    x2: 13.3909,
    y1: 48.4851,
    y2: 2.89496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5b2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5b2d4",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 28.505,
    x2: 3.49559,
    y1: 15.9999,
    y2: 16.1214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#257ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206041,
    stopColor: "#237bc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225408,
    stopColor: "#4190db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485304,
    stopColor: "#49a5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509045,
    stopColor: "#2484d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763942,
    stopColor: "#2488d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787683,
    stopColor: "#4aa6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4babfc"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0269,
    x2: 26.0243,
    y1: 14.9903,
    y2: 14.9903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46bf86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141696,
    stopColor: "#46bf86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189883,
    stopColor: "#5ce09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717341,
    stopColor: "#50cc8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77725,
    stopColor: "#43be81"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 4.02914,
    x2: 14.0269,
    y1: 15.4902,
    y2: 15.4902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61e7a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480822,
    stopColor: "#61e7a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533958,
    stopColor: "#46c687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46c687"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0252,
    x2: 26.0243,
    y1: 18.5627,
    y2: 18.5627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ec88c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320024,
    stopColor: "#4ec88c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441145,
    stopColor: "#42b483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45b683"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 23.025,
    x2: 26.0243,
    y1: 21.4889,
    y2: 21.4889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4bbd8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0621,
    stopColor: "#4bbd8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119405,
    stopColor: "#43b385"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.57505 5.33487 6.17566-1.76173c.17932-.05116.36937-.05116.54869.00001l6.4565 1.84209c.1795.05121.3697.05117.5491-.00011l6.4451-1.84169c.1797-.05135.3702-.05131.5499.0001l6.155 1.76133c.3.08.51.35.51.66v21.82003c0 .44-.42.77-.85.66l-5.7905-1.8827c-.1891-.0614-.3923-.0651-.5835-.0106l-6.4309 1.8348c-.1798.0513-.3703.0512-.55-.0003l-6.44105-1.8469c-.19161-.055-.39528-.0514-.58485.0103l-5.82915 1.8954c-.43.11-.85-.22-.85-.66v-21.82003c0-.31.22-.58.52-.66z",
    fill: "url(#e)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.57505 5.33487 6.17566-1.76173c.17932-.05116.36937-.05116.54869.00001l6.4565 1.84209c.1795.05121.3697.05117.5491-.00011l6.4451-1.84169c.1797-.05135.3702-.05131.5499.0001l6.155 1.76133c.3.08.51.35.51.66v21.82003c0 .44-.42.77-.85.66l-5.7905-1.8827c-.1891-.0614-.3923-.0651-.5835-.0106l-6.4309 1.8348c-.1798.0513-.3703.0512-.55-.0003l-6.44105-1.8469c-.19161-.055-.39528-.0514-.58485.0103l-5.82915 1.8954c-.43.11-.85-.22-.85-.66v-21.82003c0-.31.22-.58.52-.66z",
    fill: "url(#f)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.005 6.83487 4.63396-1.21343c.25929-.0679.53204-.06508.78987.00816l6.15807 1.74935c.2668.0758.5495.07612.8165.00091l6.2266-1.75371c.2586-.07283.532-.07487.7916-.00591l4.5734 1.21464c.3.08.51.35001.51.66001v18.17251c0 .2187-.114.5156-.4656.4219l-4.5984-1.4632c-.2809-.0894-.5818-.094-.8653-.0134l-6.1685 1.7549c-.2694.0767-.5549.0763-.8241-.0009l-6.12244-1.7568c-.28069-.0805-.57878-.0774-.8577.009l-4.44244 1.3766c-.33594.082-.66552-.0969-.66552-.5469v-17.95373c0-.31.21-.58.51-.66z",
    fill: "url(#g)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.905 15.6049-.53.53c-.23.23-.35.53-.35.85s.13.63.35.85l.53.53c.08.08.18.12.29.12h.43c.22 0 .4.18.4.4v2.19c0 .22.18.4.4.4h.43c.11 0 .21-.04.29-.12l.41-.41c.3-.3.47-.71.47-1.14v-1.24c0-.06.01-.12.04-.18l.91-1.83c.03-.06.04-.12.04-.18v-.5c0-.22.18-.4.4-.4h.19c.22 0 .4.18.4.4v.19c0 .22.18.4.4.4h.19c.22 0 .4-.18.4-.4v-.19c0-.22.18-.4.4-.4h.19c.22 0 .4.18.4.4v.19c0 .22.18.4.4.4h1.12c.16 0 .31-.1.37-.25l.88-2.19c.11-.26-.09-.55-.37-.55-.22 0-.4-.18-.4-.4v-1.19c0-.22.18-.4.4-.4h.19c.22 0 .4.18.4.4v.1c0 .28.22.5.5.5s.5-.22.5-.5v-1.94c0-.86004-.7-1.55004-1.55-1.55004h-.04c-.22 0-.4.18001-.4.40001v.18998c0 .22-.18.40001-.4.40001h-1.19c-.22 0-.4-.18001-.4-.40001 0-.33-.27-.59999-.6-.59999h-.4c-.55 0-1 .45-1 1v.03c0 .11-.05.22001-.13.30001l-1.75 1.57003c-.07.07-.17.1-.27.1h-1.44c-.22 0-.4.18-.4.4v.19c0 .22-.18.4-.4.4h-.19c-.22 0-.4.18-.4.4v1.19c0 .22.18.4.4.4h.19c.22 0 .4.18.4.4v.19c0 .22-.18.4-.4.4h-.43c-.09.04-.19.08-.27.15z",
    fill: "url(#h)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.525 22.4849c.28 0 .5-.22.5-.5v-1.14c0-.22.12-.42.32-.52l1.23-.62c.27-.14.45-.42.45-.72 0-.31-.17-.59-.45-.72l-1.17-.58c-.25-.13-.53-.19-.81-.19h-.44c-.08 0-.15995-.03-.21995-.09l-1.82-1.82c-.06-.06-.09-.14-.09-.22v-.56c0-.17.13999-.31.30999-.31h.38001c.17 0 .31.14.31.31v.19c0 .28.22.5.5.5s.49995-.22.49995-.5v-.19c0-.17.14-.31.31-.31.44 0 .87-.18 1.18-.49l.29-.29c.12-.12.12-.32 0-.44l-.69-.69c-.06-.06-.09-.14-.09-.22v-.37c0-.28-.22-.5-.5-.5s-.5.22-.5.5-.21995.5-.49995.5-.5-.22-.5-.5v-.19c0-.17.13999-.31.30999-.31.18 0 .32001-.15.31001-.32l-.02-.35c-.01-.18.13-.32.31-.32h.77995c.17 0 .31-.14.31-.31v-.19c0-.28002.22-.50002.5-.50002s.5.22.5.50002v2c0 .28.22.5.5.5s.5-.22.5-.5v-.37c0-.08.03-.16.09-.22l.41-.41c.32-.32.5-.75.5-1.20003 0-.72-.58-1.29999-1.3-1.29999h-1.6c-.7 0-1.36995.28999-1.84995.79999l-.62001.67c-.31.34003-.74999.53003-1.20999.53003h-.1c-.17 0-.31-.14-.31-.31 0-.38003-.31-.69002-.69-.69002h-.62001c-.38 0-.68999.30999-.68999.69002v.37c0 .6-.24 1.18-.66 1.6l-.24001.24c-.06.06-.09.14-.09.22v.13c0 .28.33001.41.53001.22l1.25999-1.26c.13-.13.31-.21.5-.21.39 0-.29.32-.29.71v2.36c0 .6 1.24 1.17 1.66 1.59l1.25 1.25c.06.06.09.14.09.22v1.12c0 .48.19001.95.53001 1.29l.37999.38c.05996.06.08996.14.08996.22v1.37c-.02.25.21.47.48.47z",
    fill: "url(#i)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.025 17.7948v.2101c0 .31.11.6099.3.8499l.21.25c.3.37.79.5401 1.25.4301.14-.03.24-.1601.24-.3001v-.3699c0-.16.12-.2901.27-.3101l.15-.0199c.31-.03.58.2099.58.5199 0 .24.17.46.41.51l.22.0501c.19.04.37-.1001.37-.3001v-.84c0-.55-.45-1-1-1h-.86c-.09 0-.17.04-.23.1l-.37.41c-.19.21-.54.08-.54-.21 0-.17-.14-.31-.31-.31h-.38c-.17.02-.31.16-.31.33z",
    fill: "url(#j)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.025 21.3249v.67c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5v-.95c0-.31-.25-.56-.56-.56h-1.61c-.46 0-.83.38-.83.84z",
    fill: "url(#k)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.4315 5.82153 6.4375-1.89062",
    stroke: "#eae4ee",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.69727 5.76563 6.15032-1.78443",
    stroke: "#eae4ee",
    strokeLinecap: "round",
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMap);
export default __webpack_public_path__ + "static/media/world-map.7b0b4ef6ee62db073a58407f209f0fee.svg";
export { ForwardRef as ReactComponent };